<template>
    <div class="left">
        <router-link class="creator__link" :class="{'selected': ($route.name == 'CreatorListing')}" :to="{path: '/creator/edit/' + id + '/listing/'}">{{$t('page.listing.listing')}}</router-link>
        <router-link class="creator__link" :class="{'selected': ($route.name == 'CreatorEdit')}" :to="{path: '/creator/edit/' + id}">{{$t('page.creator_edit.package')}}</router-link>
    </div>
</template>

<script>
    export default {
        name: 'CreatorNavigation',
        props: {
            id: {
                type: String,
                required: true,
            },
        },
    }
</script>

<style lang="scss" scoped>
    .left{
        width: 240px;
        display: inline-block;
        background-color: #F4F4F4;
        padding: 55px 25px 50px 0;
        box-sizing: border-box;
        height: 100%;
    }
    .creator__link{
        padding-left: 25px;
        box-sizing: border-box;
        width: 100%;
        border-radius: 0 25px 25px 0;
        line-height: 48px;
        color: #575C61;
        cursor: pointer;
        margin-bottom: 25px;
        display: block;
        text-decoration: none;
    }
    .creator__link:hover, .creator__link.selected{
        background-color: #575C61;
        color: #FFFFFF;
    }
</style>